/* eslint-disable */
import Vue from 'vue'
import _ from 'underscore'
import Vuex from 'vuex'
import axios from 'axios'
import qs from 'querystring'
import uniqid from 'uniqid'
import moment from 'moment-timezone'
import {
  submitEmail,
  firstInvite,
  secondInvite,
  thirdInvite,
  fourthInvite,
  fifthInvite,
  sixthInvite,
  seventhInvite,
  eighthInvite,
  ninthInvite,
  tenthInvite
} from '../assets/emails'
const ics = require('ics')
Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    modal: false
  },
  mutations: {
    setModal(state, payload) {
      state.modal = payload
    }
  },
  actions: {
    sendEmail({ commit }, form) {
      const preparedForm = {
        action: 'SENDMAIL',
        nameFrom: 'Larkspur-RiXtrema',
        mailFrom: 'extrem24@mail.rixtrema.com',
        MailTo: form.email,
        mailCopy: '',
        mailSubject: encodeURIComponent(
          '10 DAYS TO PORTFOLIO RISK MASTERY: FREE CHALLENGE  - Next Steps'
        ),
        mailMessage: encodeURIComponent(submitEmail),
        SystemType: 'BIONIX'
      }

      const config = {
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        }
      }

      return axios.post(
        `https://rixtrema.net/RixtremaWS/AJAXBIONIX.aspx`,
        // `https://thingproxy.freeboard.io/fetch/https://rixtrema.net/RixtremaWS/AJAXBIONIX.aspx`,
        qs.stringify(preparedForm),
        config
      )
    },
    sendInvite1({}, form) {
      return new Promise(resolve => {
        const config = {
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
          }
        }

        let strStartTime = '2022-05-10 12:00:00'
        let strEndTime = '2022-05-10 13:00:00'

        // parse with NYC time, and then convert to UTC
        let startTime = moment.tz(strStartTime, 'America/New_York').utc()
        let endTime = moment.tz(strEndTime, 'America/New_York').utc()

        // convert dates to array
        startTime = [
          startTime.get('year'),
          startTime.get('month') + 1,
          startTime.get('date'),
          startTime.get('hour'),
          startTime.get('minute')
        ]
        endTime = [
          endTime.get('year'),
          endTime.get('month') + 1,
          endTime.get('date'),
          endTime.get('hour'),
          endTime.get('minute')
        ]

        const event = {
          start: startTime,
          startInputType: 'utc', // I define the start time as UTC
          end: endTime,
          endInputType: 'utc', // I define the start time as UTC
          title:
            '10 Days to Risk Mastery Session 1: Foundations of Risk - Part 1',
          description: firstInvite,
          location: 'Zoom Meeting',
          status: 'CONFIRMED',
          busyStatus: 'FREE',
          organizer: {
            name: 'Daniel Satchkov',
            email: 'dsatchkov@rixtrema.com'
          },
          attendees: [
            {
              name: `${form.firstName} ${form.lastName}`,
              email: form.email,
              rsvp: true,
              partstat: 'ACCEPTED',
              role: 'REQ-PARTICIPANT'
            }
          ]
        }

        ics.createEvent(event, (error, value) => {
          if (error) {
            console.log(error)
            return
          }

          const newline = '\r\n'

          const mailHeaders =
            'From: Daniel Satchkov <dsatchkov@rixtrema.com>' +
            newline +
            '\
MIME-Version: 1.0' +
            newline +
            '\
Content-Type: text/calendar; charset=utf-8; method=REQUEST' +
            newline +
            '\
Content-Transfer-Encoding: 7bit'

          const preparedForm = {
            action: 'SENDMAIL',
            nameFrom: 'Larkspur-RiXtrema',
            mailFrom: 'extrem24@mail.rixtrema.com',
            MailTo: form.email,
            mailCopy: '',
            mailSubject: encodeURIComponent(
              '10 Days to Risk Mastery Session 1: Foundations of Risk - Part 1'
            ),
            mailMessage: value,
            MailHeaders: encodeURIComponent(mailHeaders)
          }
          axios
            .post(
              'https://rixtrema.net/RixtremaWS/AJAXBIONIX.aspx',
              // 'https://cors-anywhere.herokuapp.com/https://rixtrema.net/RixtremaWS/AJAXBIONIX.aspx',
              qs.stringify(preparedForm),
              config
            )
            .then(res => resolve(res))
            .catch(err => console.log(err))
        })
      })
    },
    sendInvite2({}, form) {
      return new Promise(resolve => {
        const config = {
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
          }
        }

        let strStartTime = '2022-05-12 12:00:00'
        let strEndTime = '2022-05-12 13:00:00'

        // parse with NYC time, and then convert to UTC
        let startTime = moment.tz(strStartTime, 'America/New_York').utc()
        let endTime = moment.tz(strEndTime, 'America/New_York').utc()

        // convert dates to array
        startTime = [
          startTime.get('year'),
          startTime.get('month') + 1,
          startTime.get('date'),
          startTime.get('hour'),
          startTime.get('minute')
        ]
        endTime = [
          endTime.get('year'),
          endTime.get('month') + 1,
          endTime.get('date'),
          endTime.get('hour'),
          endTime.get('minute')
        ]

        const event = {
          start: startTime,
          startInputType: 'utc', // I define the start time as UTC
          end: endTime,
          endInputType: 'utc', // I define the start time as UTC
          title:
            '10 Days to Risk Mastery Session 2: Foundations of Risk - Part 2',
          description: secondInvite,
          location: 'Zoom Meeting',
          status: 'CONFIRMED',
          busyStatus: 'FREE',
          organizer: {
            name: 'Daniel Satchkov',
            email: 'dsatchkov@rixtrema.com'
          },
          attendees: [
            {
              name: `${form.firstName} ${form.lastName}`,
              email: form.email,
              rsvp: true,
              partstat: 'ACCEPTED',
              role: 'REQ-PARTICIPANT'
            }
          ]
        }

        ics.createEvent(event, (error, value) => {
          if (error) {
            console.log(error)
            return
          }

          const newline = '\r\n'

          const mailHeaders =
            'From: Daniel Satchkov <dsatchkov@rixtrema.com>' +
            newline +
            '\
MIME-Version: 1.0' +
            newline +
            '\
Content-Type: text/calendar; charset=utf-8; method=REQUEST' +
            newline +
            '\
Content-Transfer-Encoding: 7bit'

          const preparedForm = {
            action: 'SENDMAIL',
            nameFrom: 'Larkspur-RiXtrema',
            mailFrom: 'extrem24@mail.rixtrema.com',
            MailTo: form.email,
            mailCopy: '',
            mailSubject: encodeURIComponent(
              '10 Days to Risk Mastery Session 2: Foundations of Risk - Part 2'
            ),
            mailMessage: value,
            MailHeaders: encodeURIComponent(mailHeaders)
          }
          axios
            .post(
              'https://rixtrema.net/RixtremaWS/AJAXBIONIX.aspx',
              // 'https://cors-anywhere.herokuapp.com/https://rixtrema.net/RixtremaWS/AJAXBIONIX.aspx',
              qs.stringify(preparedForm),
              config
            )
            .then(res => resolve(res))
            .catch(err => console.log(err))
        })
      })
    },
    sendInvite3({}, form) {
      return new Promise(resolve => {
        const config = {
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
          }
        }
        let strStartTime = '2022-05-17 12:00:00'
        let strEndTime = '2022-05-17 13:00:00'

        // parse with NYC time, and then convert to UTC
        let startTime = moment.tz(strStartTime, 'America/New_York').utc()
        let endTime = moment.tz(strEndTime, 'America/New_York').utc()

        // convert dates to array
        startTime = [
          startTime.get('year'),
          startTime.get('month') + 1,
          startTime.get('date'),
          startTime.get('hour'),
          startTime.get('minute')
        ]
        endTime = [
          endTime.get('year'),
          endTime.get('month') + 1,
          endTime.get('date'),
          endTime.get('hour'),
          endTime.get('minute')
        ]

        const event = {
          start: startTime,
          startInputType: 'utc', // I define the start time as UTC
          end: endTime,
          endInputType: 'utc', // I define the start time as UTC
          title:
            '10 Days to Risk Mastery Session 3: Equity Risk Management - Part 1: Basics',
          description: thirdInvite,
          location: 'Zoom Meeting',
          status: 'CONFIRMED',
          busyStatus: 'FREE',
          organizer: {
            name: 'Daniel Satchkov',
            email: 'dsatchkov@rixtrema.com'
          },
          attendees: [
            {
              name: `${form.firstName} ${form.lastName}`,
              email: form.email,
              rsvp: true,
              partstat: 'ACCEPTED',
              role: 'REQ-PARTICIPANT'
            }
          ]
        }

        ics.createEvent(event, (error, value) => {
          if (error) {
            console.log(error)
            return
          }

          const newline = '\r\n'

          const mailHeaders =
            'From: Daniel Satchkov <dsatchkov@rixtrema.com>' +
            newline +
            '\
MIME-Version: 1.0' +
            newline +
            '\
Content-Type: text/calendar; charset=utf-8; method=REQUEST' +
            newline +
            '\
Content-Transfer-Encoding: 7bit'

          const preparedForm = {
            action: 'SENDMAIL',
            nameFrom: 'Larkspur-RiXtrema',
            mailFrom: 'extrem24@mail.rixtrema.com',
            MailTo: form.email,
            mailCopy: '',
            mailSubject: encodeURIComponent(
              '10 Days to Risk Mastery Session 3: Equity Risk Management - Part 1: Basics'
            ),
            mailMessage: value,
            MailHeaders: encodeURIComponent(mailHeaders)
          }
          axios
            .post(
              'https://rixtrema.net/RixtremaWS/AJAXBIONIX.aspx',
              // 'https://cors-anywhere.herokuapp.com/https://rixtrema.net/RixtremaWS/AJAXBIONIX.aspx',
              qs.stringify(preparedForm),
              config
            )
            .then(res => resolve(res))
            .catch(err => console.log(err))
        })
      })
    },
    sendInvite4({}, form) {
      return new Promise(resolve => {
        const config = {
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
          }
        }
        let strStartTime = '2022-05-19 12:00:00'
        let strEndTime = '2022-05-19 13:00:00'

        // parse with NYC time, and then convert to UTC
        let startTime = moment.tz(strStartTime, 'America/New_York').utc()
        let endTime = moment.tz(strEndTime, 'America/New_York').utc()

        // convert dates to array
        startTime = [
          startTime.get('year'),
          startTime.get('month') + 1,
          startTime.get('date'),
          startTime.get('hour'),
          startTime.get('minute')
        ]
        endTime = [
          endTime.get('year'),
          endTime.get('month') + 1,
          endTime.get('date'),
          endTime.get('hour'),
          endTime.get('minute')
        ]

        const event = {
          start: startTime,
          startInputType: 'utc', // I define the start time as UTC
          end: endTime,
          endInputType: 'utc', // I define the start time as UTC
          title:
            '10 Days to Risk Mastery Session 4: Equity Risk Management - Part 2: Portfolios',
          description: fourthInvite,
          location: 'Zoom Meeting',
          status: 'CONFIRMED',
          busyStatus: 'FREE',
          organizer: {
            name: 'Daniel Satchkov',
            email: 'dsatchkov@rixtrema.com'
          },
          attendees: [
            {
              name: `${form.firstName} ${form.lastName}`,
              email: form.email,
              rsvp: true,
              partstat: 'ACCEPTED',
              role: 'REQ-PARTICIPANT'
            }
          ]
        }

        ics.createEvent(event, (error, value) => {
          if (error) {
            console.log(error)
            return
          }

          const newline = '\r\n'

          const mailHeaders =
            'From: Daniel Satchkov <dsatchkov@rixtrema.com>' +
            newline +
            '\
MIME-Version: 1.0' +
            newline +
            '\
Content-Type: text/calendar; charset=utf-8; method=REQUEST' +
            newline +
            '\
Content-Transfer-Encoding: 7bit'

          const preparedForm = {
            action: 'SENDMAIL',
            nameFrom: 'Larkspur-RiXtrema',
            mailFrom: 'extrem24@mail.rixtrema.com',
            MailTo: form.email,
            mailCopy: '',
            mailSubject: encodeURIComponent(
              '10 Days to Risk Mastery Session 4: Equity Risk Management - Part 2: Portfolios'
            ),
            mailMessage: value,
            MailHeaders: encodeURIComponent(mailHeaders)
          }
          axios
            .post(
              'https://rixtrema.net/RixtremaWS/AJAXBIONIX.aspx',
              // 'https://cors-anywhere.herokuapp.com/https://rixtrema.net/RixtremaWS/AJAXBIONIX.aspx',
              qs.stringify(preparedForm),
              config
            )
            .then(res => resolve(res))
            .catch(err => console.log(err))
        })
      })
    },
    sendInvite5({}, form) {
      return new Promise(resolve => {
        const config = {
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
          }
        }
        let strStartTime = '2022-05-24 12:00:00'
        let strEndTime = '2022-05-24 13:00:00'

        // parse with NYC time, and then convert to UTC
        let startTime = moment.tz(strStartTime, 'America/New_York').utc()
        let endTime = moment.tz(strEndTime, 'America/New_York').utc()

        // convert dates to array
        startTime = [
          startTime.get('year'),
          startTime.get('month') + 1,
          startTime.get('date'),
          startTime.get('hour'),
          startTime.get('minute')
        ]
        endTime = [
          endTime.get('year'),
          endTime.get('month') + 1,
          endTime.get('date'),
          endTime.get('hour'),
          endTime.get('minute')
        ]

        const event = {
          start: startTime,
          startInputType: 'utc', // I define the start time as UTC
          end: endTime,
          endInputType: 'utc', // I define the start time as UTC
          title:
            '10 Days to Risk Mastery Session 5: Fixed Income Risk Management - Part 1: Risk Factors',
          description: fifthInvite,
          location: 'Zoom Meeting',
          status: 'CONFIRMED',
          busyStatus: 'FREE',
          organizer: {
            name: 'Daniel Satchkov',
            email: 'dsatchkov@rixtrema.com'
          },
          attendees: [
            {
              name: `${form.firstName} ${form.lastName}`,
              email: form.email,
              rsvp: true,
              partstat: 'ACCEPTED',
              role: 'REQ-PARTICIPANT'
            }
          ]
        }

        ics.createEvent(event, (error, value) => {
          if (error) {
            console.log(error)
            return
          }

          const newline = '\r\n'

          const mailHeaders =
            'From: Daniel Satchkov <dsatchkov@rixtrema.com>' +
            newline +
            '\
MIME-Version: 1.0' +
            newline +
            '\
Content-Type: text/calendar; charset=utf-8; method=REQUEST' +
            newline +
            '\
Content-Transfer-Encoding: 7bit'

          const preparedForm = {
            action: 'SENDMAIL',
            nameFrom: 'Larkspur-RiXtrema',
            mailFrom: 'extrem24@mail.rixtrema.com',
            MailTo: form.email,
            mailCopy: '',
            mailSubject: encodeURIComponent(
              '10 Days to Risk Mastery Session 5: Fixed Income Risk Management - Part 1: Risk Factors'
            ),
            mailMessage: value,
            MailHeaders: encodeURIComponent(mailHeaders)
          }
          axios
            .post(
              'https://rixtrema.net/RixtremaWS/AJAXBIONIX.aspx',
              // 'https://cors-anywhere.herokuapp.com/https://rixtrema.net/RixtremaWS/AJAXBIONIX.aspx',
              qs.stringify(preparedForm),
              config
            )
            .then(res => resolve(res))
            .catch(err => console.log(err))
        })
      })
    },
    sendInvite6({}, form) {
      return new Promise(resolve => {
        const config = {
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
          }
        }
        let strStartTime = '2022-05-26 12:00:00'
        let strEndTime = '2022-05-26 13:00:00'

        // parse with NYC time, and then convert to UTC
        let startTime = moment.tz(strStartTime, 'America/New_York').utc()
        let endTime = moment.tz(strEndTime, 'America/New_York').utc()

        // convert dates to array
        startTime = [
          startTime.get('year'),
          startTime.get('month') + 1,
          startTime.get('date'),
          startTime.get('hour'),
          startTime.get('minute')
        ]
        endTime = [
          endTime.get('year'),
          endTime.get('month') + 1,
          endTime.get('date'),
          endTime.get('hour'),
          endTime.get('minute')
        ]

        const event = {
          start: startTime,
          startInputType: 'utc', // I define the start time as UTC
          end: endTime,
          endInputType: 'utc', // I define the start time as UTC
          title:
            '10 Days to Risk Mastery Session 6: Fixed Income Risk Management - Part 2: Curves',
          description: sixthInvite,
          location: 'Zoom Meeting',
          status: 'CONFIRMED',
          busyStatus: 'FREE',
          organizer: {
            name: 'Daniel Satchkov',
            email: 'dsatchkov@rixtrema.com'
          },
          attendees: [
            {
              name: `${form.firstName} ${form.lastName}`,
              email: form.email,
              rsvp: true,
              partstat: 'ACCEPTED',
              role: 'REQ-PARTICIPANT'
            }
          ]
        }

        ics.createEvent(event, (error, value) => {
          if (error) {
            console.log(error)
            return
          }

          const newline = '\r\n'

          const mailHeaders =
            'From: Daniel Satchkov <dsatchkov@rixtrema.com>' +
            newline +
            '\
MIME-Version: 1.0' +
            newline +
            '\
Content-Type: text/calendar; charset=utf-8; method=REQUEST' +
            newline +
            '\
Content-Transfer-Encoding: 7bit'

          const preparedForm = {
            action: 'SENDMAIL',
            nameFrom: 'Larkspur-RiXtrema',
            mailFrom: 'extrem24@mail.rixtrema.com',
            MailTo: form.email,
            mailCopy: '',
            mailSubject: encodeURIComponent(
              '10 Days to Risk Mastery Session 6: Fixed Income Risk Management - Part 2: Curves'
            ),
            mailMessage: value,
            MailHeaders: encodeURIComponent(mailHeaders)
          }
          axios
            .post(
              'https://rixtrema.net/RixtremaWS/AJAXBIONIX.aspx',
              // 'https://cors-anywhere.herokuapp.com/https://rixtrema.net/RixtremaWS/AJAXBIONIX.aspx',
              qs.stringify(preparedForm),
              config
            )
            .then(res => resolve(res))
            .catch(err => console.log(err))
        })
      })
    },
    sendInvite7({}, form) {
      return new Promise(resolve => {
        const config = {
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
          }
        }
        let strStartTime = '2022-05-31 12:00:00'
        let strEndTime = '2022-05-31 13:00:00'

        // parse with NYC time, and then convert to UTC
        let startTime = moment.tz(strStartTime, 'America/New_York').utc()
        let endTime = moment.tz(strEndTime, 'America/New_York').utc()

        // convert dates to array
        startTime = [
          startTime.get('year'),
          startTime.get('month') + 1,
          startTime.get('date'),
          startTime.get('hour'),
          startTime.get('minute')
        ]
        endTime = [
          endTime.get('year'),
          endTime.get('month') + 1,
          endTime.get('date'),
          endTime.get('hour'),
          endTime.get('minute')
        ]

        const event = {
          start: startTime,
          startInputType: 'utc', // I define the start time as UTC
          end: endTime,
          endInputType: 'utc', // I define the start time as UTC
          title:
            '10 Days to Risk Mastery Session 7: Behavioral and Historical Aspects of Risk',
          description: seventhInvite,
          location: 'Zoom Meeting',
          status: 'CONFIRMED',
          busyStatus: 'FREE',
          organizer: {
            name: 'Daniel Satchkov',
            email: 'dsatchkov@rixtrema.com'
          },
          attendees: [
            {
              name: `${form.firstName} ${form.lastName}`,
              email: form.email,
              rsvp: true,
              partstat: 'ACCEPTED',
              role: 'REQ-PARTICIPANT'
            }
          ]
        }

        ics.createEvent(event, (error, value) => {
          if (error) {
            console.log(error)
            return
          }

          const newline = '\r\n'

          const mailHeaders =
            'From: Daniel Satchkov <dsatchkov@rixtrema.com>' +
            newline +
            '\
MIME-Version: 1.0' +
            newline +
            '\
Content-Type: text/calendar; charset=utf-8; method=REQUEST' +
            newline +
            '\
Content-Transfer-Encoding: 7bit'

          const preparedForm = {
            action: 'SENDMAIL',
            nameFrom: 'Larkspur-RiXtrema',
            mailFrom: 'extrem24@mail.rixtrema.com',
            MailTo: form.email,
            mailCopy: '',
            mailSubject: encodeURIComponent(
              '10 Days to Risk Mastery Session 7: Behavioral and Historical Aspects of Risk'
            ),
            mailMessage: value,
            MailHeaders: encodeURIComponent(mailHeaders)
          }
          axios
            .post(
              'https://rixtrema.net/RixtremaWS/AJAXBIONIX.aspx',
              // 'https://cors-anywhere.herokuapp.com/https://rixtrema.net/RixtremaWS/AJAXBIONIX.aspx',
              qs.stringify(preparedForm),
              config
            )
            .then(res => resolve(res))
            .catch(err => console.log(err))
        })
      })
    },
    sendInvite8({}, form) {
      return new Promise(resolve => {
        const config = {
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
          }
        }
        let strStartTime = '2022-06-02 12:00:00'
        let strEndTime = '2022-06-02 13:00:00'

        // parse with NYC time, and then convert to UTC
        let startTime = moment.tz(strStartTime, 'America/New_York').utc()
        let endTime = moment.tz(strEndTime, 'America/New_York').utc()

        // convert dates to array
        startTime = [
          startTime.get('year'),
          startTime.get('month') + 1,
          startTime.get('date'),
          startTime.get('hour'),
          startTime.get('minute')
        ]
        endTime = [
          endTime.get('year'),
          endTime.get('month') + 1,
          endTime.get('date'),
          endTime.get('hour'),
          endTime.get('minute')
        ]

        const event = {
          start: startTime,
          startInputType: 'utc', // I define the start time as UTC
          end: endTime,
          endInputType: 'utc', // I define the start time as UTC
          title:
            '10 Days to Risk Mastery Session 8: Analyzing Portfolio Risks',
          description: eighthInvite,
          location: 'Zoom Meeting',
          status: 'CONFIRMED',
          busyStatus: 'FREE',
          organizer: {
            name: 'Daniel Satchkov',
            email: 'dsatchkov@rixtrema.com'
          },
          attendees: [
            {
              name: `${form.firstName} ${form.lastName}`,
              email: form.email,
              rsvp: true,
              partstat: 'ACCEPTED',
              role: 'REQ-PARTICIPANT'
            }
          ]
        }

        ics.createEvent(event, (error, value) => {
          if (error) {
            console.log(error)
            return
          }

          const newline = '\r\n'

          const mailHeaders =
            'From: Daniel Satchkov <dsatchkov@rixtrema.com>' +
            newline +
            '\
MIME-Version: 1.0' +
            newline +
            '\
Content-Type: text/calendar; charset=utf-8; method=REQUEST' +
            newline +
            '\
Content-Transfer-Encoding: 7bit'

          const preparedForm = {
            action: 'SENDMAIL',
            nameFrom: 'Larkspur-RiXtrema',
            mailFrom: 'extrem24@mail.rixtrema.com',
            MailTo: form.email,
            mailCopy: '',
            mailSubject: encodeURIComponent(
              '10 Days to Risk Mastery Session 8: Analyzing Portfolio Risks'
            ),
            mailMessage: value,
            MailHeaders: encodeURIComponent(mailHeaders)
          }
          axios
            .post(
              'https://rixtrema.net/RixtremaWS/AJAXBIONIX.aspx',
              // 'https://cors-anywhere.herokuapp.com/https://rixtrema.net/RixtremaWS/AJAXBIONIX.aspx',
              qs.stringify(preparedForm),
              config
            )
            .then(res => resolve(res))
            .catch(err => console.log(err))
        })
      })
    },
    sendInvite9({}, form) {
      return new Promise(resolve => {
        const config = {
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
          }
        }
        let strStartTime = '2022-06-07 12:00:00'
        let strEndTime = '2022-06-07 13:00:00'

        // parse with NYC time, and then convert to UTC
        let startTime = moment.tz(strStartTime, 'America/New_York').utc()
        let endTime = moment.tz(strEndTime, 'America/New_York').utc()

        // convert dates to array
        startTime = [
          startTime.get('year'),
          startTime.get('month') + 1,
          startTime.get('date'),
          startTime.get('hour'),
          startTime.get('minute')
        ]
        endTime = [
          endTime.get('year'),
          endTime.get('month') + 1,
          endTime.get('date'),
          endTime.get('hour'),
          endTime.get('minute')
        ]

        const event = {
          start: startTime,
          startInputType: 'utc', // I define the start time as UTC
          end: endTime,
          endInputType: 'utc', // I define the start time as UTC
          title:
            '10 Days to Risk Mastery Session 9: Advanced Topics: Cryptocurrency, Structured Notes, options, etc.',
          description: ninthInvite,
          location: 'Zoom Meeting',
          status: 'CONFIRMED',
          busyStatus: 'FREE',
          organizer: {
            name: 'Daniel Satchkov',
            email: 'dsatchkov@rixtrema.com'
          },
          attendees: [
            {
              name: `${form.firstName} ${form.lastName}`,
              email: form.email,
              rsvp: true,
              partstat: 'ACCEPTED',
              role: 'REQ-PARTICIPANT'
            }
          ]
        }

        ics.createEvent(event, (error, value) => {
          if (error) {
            console.log(error)
            return
          }

          const newline = '\r\n'

          const mailHeaders =
            'From: Daniel Satchkov <dsatchkov@rixtrema.com>' +
            newline +
            '\
MIME-Version: 1.0' +
            newline +
            '\
Content-Type: text/calendar; charset=utf-8; method=REQUEST' +
            newline +
            '\
Content-Transfer-Encoding: 7bit'

          const preparedForm = {
            action: 'SENDMAIL',
            nameFrom: 'Larkspur-RiXtrema',
            mailFrom: 'extrem24@mail.rixtrema.com',
            MailTo: form.email,
            mailCopy: '',
            mailSubject: encodeURIComponent(
              '10 Days to Risk Mastery Session 9: Advanced Topics: Cryptocurrency, Structured Notes, options, etc.'
            ),
            mailMessage: value,
            MailHeaders: encodeURIComponent(mailHeaders)
          }
          axios
            .post(
              'https://rixtrema.net/RixtremaWS/AJAXBIONIX.aspx',
              // 'https://cors-anywhere.herokuapp.com/https://rixtrema.net/RixtremaWS/AJAXBIONIX.aspx',
              qs.stringify(preparedForm),
              config
            )
            .then(res => resolve(res))
            .catch(err => console.log(err))
        })
      })
    },
    sendInvite10({}, form) {
      return new Promise(resolve => {
        const config = {
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
          }
        }
        let strStartTime = '2022-06-09 12:00:00'
        let strEndTime = '2022-06-09 13:00:00'

        // parse with NYC time, and then convert to UTC
        let startTime = moment.tz(strStartTime, 'America/New_York').utc()
        let endTime = moment.tz(strEndTime, 'America/New_York').utc()

        // convert dates to array
        startTime = [
          startTime.get('year'),
          startTime.get('month') + 1,
          startTime.get('date'),
          startTime.get('hour'),
          startTime.get('minute')
        ]
        endTime = [
          endTime.get('year'),
          endTime.get('month') + 1,
          endTime.get('date'),
          endTime.get('hour'),
          endTime.get('minute')
        ]

        const event = {
          start: startTime,
          startInputType: 'utc', // I define the start time as UTC
          end: endTime,
          endInputType: 'utc', // I define the start time as UTC
          title:
            '10 Days to Risk Mastery Session 10: Winning Clients with Risk Management',
          description: tenthInvite,
          location: 'Zoom Meeting',
          status: 'CONFIRMED',
          busyStatus: 'FREE',
          organizer: {
            name: 'Daniel Satchkov',
            email: 'dsatchkov@rixtrema.com'
          },
          attendees: [
            {
              name: `${form.firstName} ${form.lastName}`,
              email: form.email,
              rsvp: true,
              partstat: 'ACCEPTED',
              role: 'REQ-PARTICIPANT'
            }
          ]
        }

        ics.createEvent(event, (error, value) => {
          if (error) {
            console.log(error)
            return
          }

          const newline = '\r\n'

          const mailHeaders =
            'From: Daniel Satchkov <dsatchkov@rixtrema.com>' +
            newline +
            '\
MIME-Version: 1.0' +
            newline +
            '\
Content-Type: text/calendar; charset=utf-8; method=REQUEST' +
            newline +
            '\
Content-Transfer-Encoding: 7bit'

          const preparedForm = {
            action: 'SENDMAIL',
            nameFrom: 'Larkspur-RiXtrema',
            mailFrom: 'extrem24@mail.rixtrema.com',
            MailTo: form.email,
            mailCopy: '',
            mailSubject: encodeURIComponent(
              '10 Days to Risk Mastery Session 10: Winning Clients with Risk Management'
            ),
            mailMessage: value,
            MailHeaders: encodeURIComponent(mailHeaders)
          }
          axios
            .post(
              'https://rixtrema.net/RixtremaWS/AJAXBIONIX.aspx',
              // 'https://cors-anywhere.herokuapp.com/https://rixtrema.net/RixtremaWS/AJAXBIONIX.aspx',
              qs.stringify(preparedForm),
              config
            )
            .then(res => resolve(res))
            .catch(err => console.log(err))
        })
      })
    },
    logUser({}, form) {
      
      const data = {
        action: 'QUESTIONNAIREANSWER',
        userId: uniqid(),
        uid: 'riskchallenge0222',
        answer: JSON.stringify({ ...form, phone: Number(form.phone), date : new Date().getTime() }),
        ip: '',
        refferer: '',        
        date: '202205101508'
      }

      return axios.get(
        'https://rixtrema.net/RixtremaWS/AJAXPCT.aspx?' +
          _.map(data, function(d, i) {
            return i + '=' + encodeURIComponent(d)
          }).join('&')
      )
    }
  }
})
